import { useContext } from "react";
import { splitValueUnit } from "lib/helpers";
import { useStyle } from "lib/hooks";
import { TreeContext } from "pages/Editor";

export function processUnit(value, unit) {
  return value === 0 ? "" : unit;
}

function processValue(v) {
  const { value, unit } = splitValueUnit(v);
  return value + processUnit(value, unit);
}

function Input({ className, attr }) {
  const [style, setStyle] = useStyle(attr);
  const onChange = ({ target: { value } }) => setStyle(value);
  const onKeyDown = ({ keyCode, target }) => {
    const { value, unit } = splitValueUnit(target.value, "px");
    let cValue = value + (keyCode === 38 ? 1 : -1);
    let cUnit = processUnit(cValue, unit);
    if (keyCode === 38 || keyCode === 40) {
      setStyle(cValue + cUnit);
    }
  };
  const value = processValue(style || "0");
  let width = 12; // min width
  if (value.length > 1) width = width + (value.length - 1) * 6;
  return (
    <input
      type="text"
      {...{ className, onChange, onKeyDown, value, style: { width } }}
    />
  );
}

export default function BoxModel() {
  const { selection } = useContext(TreeContext);
  // TODO: remove safety check
  return selection ? (
    <div className="bm">
      <div className="bm-l">margin</div>
      <Input className="b" attr="margin-bottom" />
      <Input className="t" attr="margin-top" />
      <Input className="l" attr="margin-left" />
      <Input className="r" attr="margin-right" />
      <div className="bm1">
        <div className="bm-l">border</div>
        <div className="bm-l p">padding</div>
        <Input className="b" attr="border-bottom-width" />
        <Input className="t" attr="border-top-width" />
        <Input className="l" attr="border-left-width" />
        <Input className="r" attr="border-right-width" />
        <div className="bm2">
          <Input className="t" attr="padding-top" />
          <Input className="b" attr="padding-bottom" />
          <Input className="l" attr="padding-left" />
          <Input className="r" attr="padding-right" />
          {selection.ref.offsetWidth + "x" + selection.ref.offsetHeight}
        </div>
      </div>
    </div>
  ) : null;
}
